import { Component, OnChanges, Input } from '@angular/core';
import { GSPDayToken, GreenStickerPlan } from '../../shared/misc-classes';
import { DataService } from '../../shared/dataservice.service';
import { GenService } from '../../shared/gen-ser.service';
@Component({
  selector: 'app-green-stkr-plan',
  templateUrl: './green-stkr-plan.component.html',
  styleUrls: ['./green-stkr-plan.component.css']
})
export class GreenStkrPlanComponent implements OnChanges {
  @Input() currMonthDtObj:Date;
  @Input() grnInspPln:GreenStickerPlan;  
  dGSPDayTokenObj:GSPDayToken;

  constructor(private _dataService: DataService) { }

  ngOnChanges() {
    this.loadDateData()
  }
  loadDateData():void{
    if(this.grnInspPln){
      let _tmpGSPDayToken:GSPDayToken = this.grnInspPln.getDateToken(this.currMonthDtObj);
      if(_tmpGSPDayToken == null){
        this.grnInspPln.addDateToken(this.currMonthDtObj);  
        _tmpGSPDayToken = this.grnInspPln.getDateToken(this.currMonthDtObj);
      }
      this.dGSPDayTokenObj = _tmpGSPDayToken;
    }
    else{
      this.dGSPDayTokenObj = new GSPDayToken(this.currMonthDtObj,[])
    }    
  }
  formatDate(_date: Date): string {
    if (_date) {
      return GenService.getDateFormatStr(_date, "DD-mmm-YYYY");
    }
    return '-';
  }
  getProductName(_prodId: string): string {
    if (_prodId)
      return this._dataService.getProductName(_prodId);
    return '';
  }
  getCustomerName(_custId: string): string {
    if (_custId)
      return this._dataService.getCustomerName(_custId);
    return '';
  }
  getData(option) {
    if (option) return option
    return ''
  }

}
